// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "title-1-lul";
var _4 = "container-1fAFi";
var _5 = "fare-3LNjp";
var _6 = "rules-1p_gR";
var _7 = "button__rules-1fQwY";
var _8 = "options-jY0mD";
var _9 = "keyFeature-fTXJz";
var _a = "option-2M63n";
var _b = "fareGroup_white-8hD9e";
var _c = "keyFeature_paid-yo4Yo";
var _d = "keyFeature__icon-3JTra";
var _e = "keyFeature__value-2EdD3";
var _f = "button-vmcWK";
export { _1 as "__esModule", _2 as "mobile", _3 as "title", _4 as "container", _5 as "fare", _6 as "rules", _7 as "button__rules", _8 as "options", _9 as "keyFeature", _a as "option", _b as "fareGroup_white", _c as "keyFeature_paid", _d as "keyFeature__icon", _e as "keyFeature__value", _f as "button" }
export default { "__esModule": _1, "mobile": _2, "title": _3, "container": _4, "fare": _5, "rules": _6, "button__rules": _7, "options": _8, "keyFeature": _9, "option": _a, "fareGroup_white": _b, "keyFeature_paid": _c, "keyFeature__icon": _d, "keyFeature__value": _e, "button": _f }
